module.exports = __webpack_public_path__ + "img/leads.efaa5ac2.svg";